const LOCALSTORAGE_LAST_VISITED = 'sxcl-last-visited';
const LOCAL_STORAGE_KEYCLOAK_CONFIG = 'KEYCLOAK_CONFIG';
const LOCAL_STORAGE_OIDC_TOKEN_NAME = 'OIDC_TOKEN_NAME';

export {
  LOCALSTORAGE_LAST_VISITED,
  LOCAL_STORAGE_KEYCLOAK_CONFIG,
  LOCAL_STORAGE_OIDC_TOKEN_NAME,
};
